/**
 * @generated SignedSource<<075456adb3b128637cf70235bb13e16d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingStyleModule_contemporaryLandingRow$data = {
  readonly items: ReadonlyArray<{
    readonly items?: ReadonlyArray<{
      readonly description?: string | null;
      readonly imagePath?: string | null;
      readonly linkData?: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
      readonly title?: string | null;
    } | null> | null;
    readonly text?: string | null;
    readonly type?: string | null;
  } | null> | null;
  readonly " $fragmentType": "ContemporaryLandingStyleModule_contemporaryLandingRow";
};
export type ContemporaryLandingStyleModule_contemporaryLandingRow$key = {
  readonly " $data"?: ContemporaryLandingStyleModule_contemporaryLandingRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingStyleModule_contemporaryLandingRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingStyleModule_contemporaryLandingRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            (v0/*:: as any*/)
          ],
          "type": "ContemporaryLandingHeader",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imagePath",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LinkData",
                      "kind": "LinkedField",
                      "name": "linkData",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "SeoLink_linkData"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ContemporaryLandingStyleRowItem",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v0/*:: as any*/)
          ],
          "type": "ContemporaryLandingRow",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingRow",
  "abstractKey": null
};
})();

(node as any).hash = "069002ac4d1b4d08a5cd13e91278c1e2";

export default node;
